import { forwardRef, type CSSProperties } from 'react';

/**
 * Ce qui parait dans le creux quand on tire pour relire.
 *
 * Douze rais, comme l'indicateur du systeme : il se fond dans ce que le
 * pouce connait deja. Ils paraissent un a un a mesure que le contenu
 * descend ; au dernier, lacher relira, et la roue tourne le temps de la
 * relecture.
 *
 * # Ou il vit
 *
 * Derriere le contenu, pas au-dessus. Le bloc qui defile est opaque et
 * vient apres dans l'ordre du document : il recouvre donc la roue au
 * repos, et la laisse voir en s'ecartant. Rien a cacher ni a reveler
 * soi-meme.
 *
 * # Ce qui le pilote
 *
 * `usePullToRefresh`, en ecrivant `--p` — la part du chemin parcourue,
 * de zero a un — directement sur le style. Rien ne passe par React
 * pendant le geste : ce serait un rendu de l'arbre par image pour
 * deplacer un seul noeud.
 */
export const Tirette = forwardRef<HTMLSpanElement>(function Tirette(_props, ref) {
  return (
    <span className="tirette-place" aria-hidden="true">
      <span ref={ref} className="tirette">
        {/*
          La rotation vit dans un calque a elle : le porteur garde sa
          place, et seule la roue tourne.
        */}
        <span className="tirette__roue">
          {/*
            `--i` : la place du rai, de midi dans le sens des aiguilles.
            `--r` : combien de crans il a de retard sur la tete, qui part
            de midi — la ou le dernier rai vient de paraitre.
          */}
          {Array.from({ length: 12 }, (_, rai) => (
            <i key={rai} style={{ '--i': rai, '--r': (12 - rai) % 12 } as CSSProperties} />
          ))}
        </span>
      </span>
    </span>
  );
});
